module.exports = __webpack_public_path__ + "img/IcoMiembroSVE.e85dc898.png";